import React from 'react';

import { Heading } from '@eluve/components';

import { AssetDeletionRequestsTable } from './AssetDeletionRequestsTable';

export const GlobalAssetDeletionHistoryPage: React.FC = () => {
  return (
    <div>
      <div className="my-2 py-2">
        <Heading>All Asset Deletion Requests</Heading>
      </div>

      <AssetDeletionRequestsTable />
    </div>
  );
};
